import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import TableComissions from 'views/betShopManagement/cashier/tableComissions'; // Importing TableComissions component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the cashier view for the bet shop.
 * @extends JetView
 */
export default class betShopCashierView extends JetView {
    /**
     * Configures the layout of the cashier view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration for pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Second toolbar configuration (duplicate of the first)
        const toolbar2 = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left panel configuration containing an accordion
        const left = {
            responsiveCell: false,
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'comission', // CSS class for styling
                    collapsed: false,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            label: _('Comisiones'), // Localized label for commissions
                            header: _('Comisiones'), // Localized header for commissions
                            body: {
                                rows: [TableComissions, toolbar], // Body containing TableComissions and toolbar
                            },
                        },
                    ],
                },
            ],
        };

        // Returning the main layout configuration
        return {
            type: 'wide', // Layout type
            responsive: true, // Responsive layout
            cols: [left], // Columns containing the left panel
        };
    }
}

// FILE DOCUMENTED
